export default "__VITE_ASSET__99041f95__"